// extracted by mini-css-extract-plugin
export default {"dropdown__loader":"DropdownLoader_dropdown__loader__8F3VJ","spin":"DropdownLoader_spin__nqN7L"};